import { Skeleton } from "@/components/ui/skeleton";
import ListingCard from "@/components/ListingCard";

const FeaturedListingsSection = ({ listings, loading }) => (
  <section className="py-16 md:py-20">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex items-end justify-between mb-10 flex-wrap gap-3">
        <div>
          <span className="text-sm font-medium text-[color:var(--brand-gold-2)] uppercase tracking-wide">Vitrin</span>
          <h2 className="font-[var(--font-serif)] text-2xl md:text-3xl font-semibold tracking-[-0.01em] text-[color:var(--brand-charcoal)] mt-2">
            Öne Çıkan İlanlar
          </h2>
        </div>
      </div>
      {loading ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {[1, 2, 3, 4].map((i) => (
            <Skeleton key={i} className="h-[300px] rounded-[14px]" />
          ))}
        </div>
      ) : listings.length === 0 ? (
        <p className="text-sm text-[color:hsl(var(--muted-foreground))]" data-testid="home-listings-empty">
          Henüz yayında ilan bulunmuyor.
        </p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-testid="home-featured-listings">
          {listings.map((l) => (
            <ListingCard key={l.id} listing={l} />
          ))}
        </div>
      )}
    </div>
  </section>
);

export default FeaturedListingsSection;
